import(/* webpackMode: "eager" */ "/app/src/app/language/[code]/page.tsx");
